module.exports = __webpack_public_path__ + "static/img/plan2.2e19ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/plan2.png
// module id = NAlm
// module chunks = 1